var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.respondsLoaded)?_c('section',{staticClass:"project-responds"},[_c('RespondsHeader'),_c('BaseBoard',{attrs:{"items":_vm.responds},scopedSlots:_vm._u([{key:"board-item",fn:function(ref){
var item = ref.item;
var itemIndex = ref.itemIndex;
return [_c('BaseCardShell',{attrs:{"index":itemIndex}},[_c('RespondInfo',{attrs:{"respond":item}})],1)]}}],null,false,3032384777)})],1):_c('BasePreloader')}
var staticRenderFns = []

export { render, staticRenderFns }